import React from 'react';
import makeLazyComponent from 'app/components/layout/LazyLoadingComponent';
const HttpStatusOwl400 = makeLazyComponent(() =>
  import('app/components/svgs/mascot/WakeUp'));
const HttpStatusOwl401 = makeLazyComponent(() =>
  import('app/components/svgs/mascot/Forest'));
const HttpStatusOwl403 = makeLazyComponent(() =>
  import('app/components/svgs/mascot/Window'));
const HttpStatusOwl404 = makeLazyComponent(() =>
  import('app/components/svgs/mascot/Crying'));
const HttpStatusOwl503 = makeLazyComponent(() =>
  import('app/components/svgs/mascot/Busy'));

export default function getHttpStatusOwl(status: number, width: string | number = '100%') {
  switch (status) {
    case 400:
      return <HttpStatusOwl400 width={width} data-testid="http-400" />;

    case 401:
      return <HttpStatusOwl401 width={width} data-testid="http-401" />;

    case 403:
      return <HttpStatusOwl403 width={width} data-testid="http-403" />;

    case 404:
      return <HttpStatusOwl404 width={width} data-testid="http-404" />;

    case 503:
      return <HttpStatusOwl503 width={width} data-testid="http-503" />;

    default:
      return false;
  }
}
